import Vue from 'vue';

const state = {};

const getters = {};

const mutations = {};

const actions = {
  parseAddress({ commit }, address) {
    return new Promise((resolve, reject) => {
      try {
        Vue.http.get(`${wwfconfigs.CLOUDFUNCTION}/parseAddress?address=${address}`).then(response => {
          resolve(response.body);
        }, error => {
          reject(error);
        });
      } catch (err) {
        reject(err);
      }
    });
  },
  getAddressDetails({ commit }, addressId) {
    return new Promise((resolve, reject) => {
      try {
        Vue.http.get(`${wwfconfigs.CLOUDFUNCTION}/getAddressDetails?addressId=${addressId}`).then(response => {
          resolve(response.body);
        }, error => {
          reject(error);
        });
      } catch (err) {
        reject(err);
      }
    });
  },
  validateEmail({ commit, dispatch }, email) {
    return new Promise((resolve, reject) => {
      try {
        Vue.http.get(`${wwfconfigs.CLOUDFUNCTION}/validateEmail?email=${email}`).then(async response => {
          resolve(await dispatch('processSensisEmailResponse', response.body));
        }, error => {
          reject(error);
        });
      } catch (err) {
        reject(err);
      }
    });
  },
  validatePhone({ commit, dispatch }, phone) {
    return new Promise((resolve, reject) => {
      try {
        Vue.http.get(`${wwfconfigs.CLOUDFUNCTION}/validatePhone?phone=${phone}`).then(async response => {
          resolve(await dispatch('processSensisPhoneResponse', response.body));
        }, error => {
          reject(error);
        });
      } catch (err) {
        reject(err);
      }
    });
  },
  processSensisEmailResponse({ }, sensisResponse) {
    return new Promise((resolve, reject) => {
      if (sensisResponse.status === "OK") {
        const result = sensisResponse.result

        if (result.email_valid === 'INVALID') { // Syntax
          resolve({
            valid: false,
            data: { message: "Email invalid" }
          });

        } else if (result.domain_exists === 'INVALID'
          || result.mailserver_exists === 'INVALID'
          || result.email_exists === 'INVALID') {
          resolve({
            valid: false,
            data: { message: "Email address doesn't exist on email server" }
          });

        } else { // Valid
          resolve({
            valid: true
          });
        }
      } else {
        // If the call failed, do not keep the user from donation
        resolve({
          valid: true
        });
      }
    });
  },
  processSensisPhoneResponse({ }, sensisResponse) {
    return new Promise((resolve, reject) => {
      if (sensisResponse.status === "OK") {
        const result = sensisResponse.result;

        if (
          result.phone_status !== "Active" &&
          result.phone_status !== "Unknown"
        ) {
          resolve({
            valid: false,
            data: { message: "Invalid phone number, try again" },
          });
        } else {
          // Valid
          resolve({
            valid: true,
          });
        }
      } else {
        // If the call failed, do not keep the user from donati
        resolve({
          valid: true
        });
      }
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/sensis.js